<template>
  <aside class="auth-hero">
    <div class="auth-hero__logo">
      <img
        class="auth-hero__logo-img"
        src="@/assets/logo.svg"
        alt="MentorMe"
      />
    </div>

    <h2 class="auth-hero__title">{{ $t('authHeroTitle') }}</h2>
    <p class="auth-hero__subtitle">{{ $t('authHeroSubtitle') }}</p>

    <div class="auth-hero__stats">
      <div v-for="(stat, i) in stats" :key="stat.id" class="auth-hero__stat">
        <span class="auth-hero__stat-icon">{{ stat.icon }}</span>
        <div>
          <div class="auth-hero__stat-val">{{ displayValues[i] }}</div>
          <div class="auth-hero__stat-label">{{ stat.label }}</div>
        </div>
      </div>
    </div>
  </aside>
</template>

<script>
const STATS_CONFIG = [
  { id: 'programs', target: 3540, suffix: '', icon: '🌍', labelKey: 'authStatProgramsAbroad' },
  { id: 'universities', target: 331, suffix: '', icon: '🏛️', labelKey: 'authStatUniversities' },
  { id: 'admission', target: 100, suffix: '%', icon: '✅', labelKey: 'authStatAdmission' },
  { id: 'students', target: 1000, suffix: '+', icon: '🎓', labelKey: 'authStatStudentsTrust' },
];

const ANIMATION_MS = 1800;

export default {
  name: 'AuthHeroPanel',
  data() {
    return {
      displayValues: STATS_CONFIG.map(() => '0'),
    };
  },
  computed: {
    stats() {
      return STATS_CONFIG.map((s) => ({
        ...s,
        label: this.$t(s.labelKey),
      }));
    },
  },
  mounted() {
    STATS_CONFIG.forEach((stat, i) => {
      this.animateStat(i, stat.target, stat.suffix);
    });
  },
  methods: {
    animateStat(index, target, suffix) {
      const start = performance.now();

      const tick = (now) => {
        const progress = Math.min((now - start) / ANIMATION_MS, 1);
        const eased = 1 - (1 - progress) ** 3;
        const value = Math.round(eased * target);
        this.displayValues[index] = `${value}${suffix}`;

        if (progress < 1) {
          requestAnimationFrame(tick);
        } else {
          this.displayValues[index] = `${target}${suffix}`;
        }
      };

      requestAnimationFrame(tick);
    },
  },
};
</script>
